/**
 * The ONE answer to "are we online?" for anything the user can see.
 *
 * Before this hook there were three: OfflineBanner kept its own listeners,
 * `sendState.offline` was a sample taken whenever the queue happened to
 * refresh, and SendQueueSheet read `navigator.onLine` once at render and
 * never again. Three sources, three answers, and a paddingTop hack trying
 * to reconcile two of them (BUG-122's neighborhood). Surfaces subscribe
 * here; the engine keeps its own sampled copy for its own scheduling.
 */
import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

const snapshot = () => navigator.onLine;

export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => true);
}
